import CustomBg from "../Components/CustomBg";
import {
  coins,
  coinsHeld,
  followers,
  followings,
  notifications,
  profileTabs,
  threads,
  user,
  userById,
} from "../constants";
import { Link, useSearchParams } from "react-router-dom";
import { handleCopy } from "../utils/copyToClipboard";
import CoinsHeld from "../Components/CoinsHeld";
import CoinsCreated from "../Components/CoinsCreated";
import Followers from "../Components/Followers";
import Following from "../Components/Following";
import withPagination from "../Components/withPagination";
import { useMemo, useState } from "react";
import Notifications from "../Components/Notifications";
import Threads from "../Components/Threads";
import EditProfile from "../Components/Modal/EditProfile";
import Withdraw from "../Components/Modal/Withdraw";
import Transfer from "../Components/Modal/Transfer";

const PaginatedCoinsHeld = withPagination(CoinsHeld, 10);
const PaginatedCoinsCreated = withPagination(CoinsCreated, 3);
const PaginatedFollowers = withPagination(Followers, 10);
const PaginatedFollowing = withPagination(Following, 10);
const PaginatedThreads = withPagination(Threads, 8);

const ProfilePage = ({ type }) => {
  const [searchParams] = useSearchParams();
  const currentTabId = searchParams.get("tab");
  const [showEditModal, setShowEditModal] = useState(false);
  const [showWithdrawModal, setShowWithdrawModal] = useState(false);
  const [showTransferModal, setShowTransferModal] = useState(false);

  const userData = useMemo(() => (type === "own" ? user : userById), []);

  return (
    <>
      <div className="profile-page-container">
        <CustomBg />
        <div className="profile-details-wrapper">
          <div className="profile-details">
            <div className="personal-details glass-effect">
                <Link to={"/"} className="back-btn glass-effect">
                  <div>
                      <img src="/icons/back-icon.svg" alt="" />
                  </div>
                </Link>
              <div>
                <div className="profile-border">
                  <div
                    className="profile-image"
                    style={{ backgroundImage: `url(${userData.profileImage})` }}
                  />
                </div>
                <p> &#64;{userData.username}</p>
                <div className="follower-details">
                  <div>
                    <div>
                      <span>{userData.followers}</span>
                      <span>Followers</span>
                    </div>
                    <div>
                      <span>{userData.likesReceived}</span>
                      <span>Likes Received</span>
                    </div>
                    <div>
                      <span>{userData.mentions}</span>
                      <span>Mentions</span>
                    </div>
                  </div>
                  <p>{userData.description}</p>
                </div>

                <div className="private-key-container">
                  <input type="text" value={userData.privateKey} disabled />
                  <div
                    className="copy"
                    onClick={() => handleCopy(userData.privateKey)}
                  >
                    <img src="/icons/copy.svg" alt="" />
                  </div>
                </div>

                <div className="link-container">
                  <p>
                    <Link to={"#"} className="link">
                      View on Donatuzscan
                      <img src="/icons/linkArrow.svg" alt="" />
                    </Link>
                  </p>
                </div>

                {type === "own" ? (
                  <>
                    <button
                      className="button-purple"
                      onClick={() => setShowEditModal(true)}
                    >
                      <img src="/icons/edit.svg" alt="" />
                      <span>Edit Profile</span>
                    </button>
                    <button className="button-transparent">
                      <span>Disconnect Wallet</span>
                    </button>
                    <button
                      className="button-transparent"
                      onClick={() => setShowWithdrawModal(true)}
                    >
                      <span>Withdraw from Wallet</span>
                    </button>
                    <button
                      className="button-transparent"
                      onClick={() => setShowTransferModal(true)}
                    >
                      <span>Export Wallet</span>
                    </button>
                  </>
                ) : (
                  <button className="follow-button">
                    <img src="/icons/profileIcon.svg" alt="" />
                    <span>Follow</span>
                  </button>
                )}
              </div>
            </div>
            <div className="glass-effect tabs-navigator-container">
              {profileTabs.map((tab, index) => (
                <Link
                  key={index}
                  to={`?tab=${tab.id}`}
                  className={`button-purple ${
                    currentTabId == null && tab.id == 1
                      ? ""
                      : currentTabId != tab.id
                      ? "bg-none"
                      : ""
                  }`}
                >
                  <button className="btn-styles-none">{tab.title}</button>
                </Link>
              ))}
            </div>

            <div className="profile-notifications">
              {(currentTabId == 1 || !currentTabId) && (
                <div className="hide-dust-coin">
                  <input
                    type="checkbox"
                    name="hide-dust-coin"
                    id="hide-dust-coin"
                    className="check-box"
                  />
                  <label htmlFor="hide-dust-coin">Hide Dust Coins</label>
                </div>
              )}
              {type === "own" && (
                <div className="user-notifiction">
                  <Link to={"?tab=notification"}>
                    <button
                      className={
                        currentTabId == "notification"
                          ? "button-purple"
                          : "button-transparent"
                      }
                    >
                      <img src="/icons/notification.svg" alt="Notifications" />
                    </button>
                  </Link>
                  <Link to={"?tab=recycle"}>
                    <button
                      className={
                        currentTabId == "recycle"
                          ? "button-purple"
                          : "button-transparent"
                      }
                    >
                      <img src="/icons/refresh.svg" alt="Refresh" />
                    </button>
                  </Link>
                </div>
              )}
            </div>

            <div className="tab-details">
              {currentTabId == 1 ? (
                <PaginatedCoinsHeld data={coinsHeld} />
              ) : currentTabId == 2 ? (
                <PaginatedCoinsCreated data={coins} />
              ) : currentTabId == 3 ? (
                <PaginatedFollowers data={followers} />
              ) : currentTabId == 4 ? (
                <PaginatedFollowing data={followings} />
              ) : currentTabId == "notification" ? (
                <Notifications data={notifications} />
              ) : currentTabId == "recycle" ? (
                <PaginatedThreads data={threads} />
              ) : (
                <PaginatedCoinsHeld data={coinsHeld} />
              )}
            </div>
          </div>
        </div>
      </div>

      <EditProfile show={showEditModal} setShow={setShowEditModal} />
      <Withdraw show={showWithdrawModal} setShow={setShowWithdrawModal} />
      <Transfer show={showTransferModal} setShow={setShowTransferModal} />
    </>
  );
};

export default ProfilePage;
